import { calculateLocatinVars } from '../../../libs/browser';
import { formatDate } from '../../../libs/date';
import { parseError } from '../../../libs/parser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackCloseBarComponent from '../../../components/BackCloseBarComponent';
import CommonDescription from '../../../components/CommonDescription';
import Context from '../../../provider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import React, { useContext, useEffect, useRef, useState } from 'react';
import memberApi from '../../../libs/api/memberApi';
import useIsScrolling from '../../../hooks/useIsScrolling';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function MobileMissionDetail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();

  const scrollRef = useRef();
  const isScrolling = useIsScrolling(scrollRef.current);

  const [data, setData] = useState(null);
  const [tncShow, setTncShow] = useState(false);

  const { init, dispatch, lang } = useContext(Context);

  const fetchData = async () => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const response = await memberApi.getMissionDetail({ code: location.state?.id });

      setData(response);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  useEffect(() => {
    if (init) {
      fetchData();
    }
    window.scrollTo(0, 0);
  }, [init, navigate]);

  return (
    (
      <div className='mobile-mission-detail-page'>
        <BackCloseBarComponent />
        {
          data &&
          <div ref={scrollRef} className="content-container">
            {
              data.image?.[lang] &&
              <div className="title-img" style={{ backgroundImage: `url(${data.image?.[lang]})` }}/>
            }
            <div className="mission-content-container">
              <div className="mission-title-time">
                <div className="title-text">
                  {data.title?.[lang]}
                </div>
                <div className="time-text">
                  {`${t('mission-detail.expiry')}${formatDate(data.expire_at, lang)}`}
                </div>
              </div>
              <div className="stamp-progress-container">
                <div className="title-container">
                  <div className="title-text">
                    {`${t('mission-detail.progress')}`}
                  </div>
                  <div className="progress-text">
                    {`${data.progress?.current}/${data.progress?.total}`}
                  </div>
                </div>
                {
                  data.progress_display_mode === "stamp" ?
                  <>
                    <div
                      className="stamp-container"
                      style={{ backgroundImage : `url(${data.progress_display_mode_stamp?.images?.background?.[lang]})` }}
                    >
                      {
                        [...Array(data.progress?.current)].map((item, index) => {
                          return <div key={`active-${index}`} className="stamp-item" style={{ backgroundImage: `url(${data.progress_display_mode_stamp?.images?.active?.[lang]})` }} />;
                        })
                      }
                      {
                        [...Array(data.progress?.total - data.progress?.current)].map((item, index) => {
                          return <div key={`active-${index}`} className="stamp-item" style={{ backgroundImage: `url(${data.progress_display_mode_stamp?.images?.inactive?.[lang]})` }} />;
                        })
                      }
                    </div>
                  </>
                  :
                  <>
                    <div className="progress-container">
                      <div className="bar" />
                      <div className="inner" style={{ width: `${data.progress?.percentage}%` }} />
                    </div>
                  </>
                }
              </div>
              <div className="desc-container">
                <div className="title-text">
                  {`${t('mission-detail.desc')}`}
                </div>
                <div className="desc-text">
                  <CommonDescription data={data.details?.[lang]} />
                </div>
              </div>
              {
                data.tnc?.[lang] &&
                <div className="terms-conditions-container">
                  <div className="terms-title-cont">
                    <div className="title-text">
                      {`${t('mission-detail.t&c')}`}
                    </div>
                    {
                      tncShow
                      ?
                      <KeyboardArrowUpIcon
                        className="icon"
                        size="large"
                        onClick={(e) => {
                          e.stopPropagation();
                          setTncShow(false);
                        }}
                      />
                      :
                      <KeyboardArrowDownIcon
                        className="icon"
                        size="large"
                        onClick={(e) => {
                          e.stopPropagation();
                          setTncShow(true);
                        }}
                      />
                    }
                  </div>

                  {
                    tncShow &&
                    <div className="terms-desc-cont">
                      <CommonDescription data={data.tnc?.[lang]} />
                    </div>
                  }
                </div>
              }
            </div>
            <div style={{ height: '10rem' }} />
          </div>
        }
      </div>
    )
  );
}